import React from 'react';

import { formatPhone } from '../utils/formatPhone';
import { formatZip } from '../utils/formatZip';

export const useValidation = (initialValues, validationRules, t) => {
	const [formData, setFormData] = React.useState(initialValues);
	const [errors, setErrors] = React.useState({});

	React.useEffect(() => {
		setFormData(initialValues);
		setErrors({});
	}, [initialValues]);

	const validateField = (name, value) => {
		const trimmedValue = value.trim();

		if (trimmedValue === '') {
			return `${validationRules[name]} ${t('home:required')}`;
		}

		if (name === 'email') {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (!emailRegex.test(trimmedValue)) {
				return t('home:invalidEmail');
			}
		}
		return '';
	};

	const handleInputChange = (name, value) => {
		let formattedValue = value;

		if (name === 'phone') {
			formattedValue = formatPhone(value);
		}

		if (name === 'zipCode') {
			formattedValue = formatZip(value);
		}

		if (errors[name]) {
			setErrors((prev) => ({
				...prev,
				[name]: validateField(name, formattedValue)
			}));
		}
		setFormData((prev) => ({ ...prev, [name]: formattedValue }));
	};

	const handleInputBlur = (name, value) => {
		setErrors((prev) => ({
			...prev,
			[name]: validateField(name, value)
		}));
	};

	const validateForm = () => {
		const newErrors = {};
		let valid = true;

		Object.keys(validationRules).forEach((field) => {
			const value = formData[field] ?? '';
			const error = validateField(field, value);

			if (error) {
				newErrors[field] = error;
				valid = false;
			}
		});

		setErrors(newErrors);
		return valid;
	};

	const reset = () => {
		setFormData(initialValues);
		setErrors({});
	};

	return {
		formData,
		errors,
		handleInputChange,
		handleInputBlur,
		validateForm,
		reset
	};
};
